import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.3ds_app.modal.title',
        defaultMessage: 'Open app in your phone to confirm transaction',
    },
    description: {
        id: 'modal.3ds_app.modal.description',
        defaultMessage: 'Please scan the QR to open or install the app',
    },
    ok: {
        id: 'modal.3ds_app.modal.ok',
        defaultMessage: 'OK',
    },
    open: {
        id: 'modal.3ds_app.modal.open_mobile',
        defaultMessage: 'Open mobile app',
    },
})
